import * as React from 'react';
import Table from "../../Table";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {AppUser} from "../../../types";
import {getUsers} from "../../../api";


const SearchUsers: React.FunctionComponent = () => {

    const [users, setUsers] = useState<AppUser[]>();

    useEffect(() => {
        getUsers()
            .then((u) => setUsers(u))
            .catch((e) => console.log(e));
    }, []);

    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Users</h2>
            </div>
            <div className={"col-lg-12 mb-3 "}>
                <Link to={"/m/users/add"}>
                    <button className={"btn btn-primary"}>Add User</button>
                </Link>
            </div>

            <div className={"col-lg-6 mb-3 "}>
                <Table headers={["Email", "Role"]}
                       defaultPaginationSize={10}>
                    {
                        users?.map((t) => (
                            <tr key={t.uuid}>
                                <td>
                                    {t.email}
                                </td>
                                <td>
                                    {t.role}
                                </td>
                            </tr>
                        ))
                    }

                </Table>
            </div>
        </div>
    </>);
};

export default SearchUsers;
